module.exports = __webpack_public_path__ + "static/media/no_content.d6be8fa2.svg";